export function openUrl(url,type) {

  //_self (to open on same tab)
  //_blank (to open new tab)
    const win = window.open(url,type ? type : '_blank');
    if (win != null) {
      win.focus();
    }
}